import { useMocks } from '../../shared/env';
import type { TaxPaymentsGateway } from './TaxPaymentsGateway';
import { HttpTaxPaymentsGateway } from './HttpTaxPaymentsGateway';
import { MockTaxPaymentsGateway } from './MockTaxPaymentsGateway';

export const taxPaymentsGateway: TaxPaymentsGateway = useMocks ? new MockTaxPaymentsGateway() : new HttpTaxPaymentsGateway();
export type { TaxPaymentsGateway } from './TaxPaymentsGateway';
